import { z } from 'zod';

export const ToolArgsSchema = z.record(z.string(), z.unknown());
export type ToolArgs = z.infer<typeof ToolArgsSchema>;

export const ToolParamSchema = z.object({
    type: z.string(),
    properties: ToolArgsSchema,
    required: z.array(z.string()).optional(),
})
export type ToolParam = z.infer<typeof ToolParamSchema>;

export const ToolSchema = z.object({
    name: z.string(),
    description: z.string(),
    parameters: ToolParamSchema.optional(),
    defaultArgs: ToolArgsSchema.optional(),
});
export type Tool = z.infer<typeof ToolSchema>;

export const ToolCallActionSchema = z.object({
    id: z.string(),
    name: z.string(),
    args: ToolArgsSchema.optional(),
});
export type ToolCallAction = z.infer<typeof ToolCallActionSchema>;

export const ActionMethodSchema = z.enum(['GET', 'POST', 'PUT', 'DELETE', 'PATCH', 'ALL', 'OPTIONS', 'HEAD'])
export type ActionMethod = z.infer<typeof ActionMethodSchema>;

export const HateoasTargetSchema = z.object({
    href: z.string(),
    method: ActionMethodSchema,
    label: z.string().optional(),
    title: z.string().optional(),
    chatbotHidden: z.boolean().optional(),
    tool: ToolSchema.optional(),
});
export type HateoasTarget = z.infer<typeof HateoasTargetSchema>;